import {POSTALCODE_VALIDATE_REQ, POSTALCODE_VALIDATE_REQ_FAIL} from "./postalCodeType";
import axios from "axios";
import {pinValidationAction, pinValidationFail} from "../pinValidation/pinValidationAction";


export const postalCodeAction = (postalCodeData) => {
    return {
        type: POSTALCODE_VALIDATE_REQ,
        payload: postalCodeData
    }
}

export const postalCodeActionFail = (error) => {
    return {
        type: POSTALCODE_VALIDATE_REQ_FAIL,
        payload: error
    }
}

export const validatePostalCode = (postalCodeData) => {
    return async (dispatch) => {
        function onSuccess(success) {
            dispatch(postalCodeAction(success.data))
            return success;
        }
        function onError(error) {
            dispatch(postalCodeActionFail(error.data))
            return error;
        }
        try {
            const success = await axios.post(process.env.REACT_APP_CUT_REG_BASE_URL + "/postalCodeValidate/", postalCodeData);
            return onSuccess(success);
        } catch (error) {
            return onError(error);
        }
    }
}
